<template>
  <div class="app-container">
    <router-view></router-view>
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: var(--font-primary);
}

html, body {
  height: 100%;
  background-color: var(--bg-tertiary);
  color: var(--text-primary);
  font-family: var(--font-primary);
}

.app-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: var(--font-primary);
}

/* 输入框默认字体 */
input, textarea, select, button {
  font-family: var(--font-primary);
}
</style>
